import { COURSE_LANDING_PAGE_LOAD_START, COURSE_LANDING_PAGE_LOAD_COMPLETE, COURSE_LANDING_PAGE_LOAD_ERR } from "../actionTypes";
import * as courseLandingPage from '../../api/content/courseLandingPage';
import stateConfig from '../../config/state';
import { toSerializableError } from "../../utils/errors";

const itemKey = stateConfig.keys.COURSE_LANDING_PAGE;

export function getCourseLandingPageBySlug(slug) {
  return async dispatch => {
    dispatch({ type: COURSE_LANDING_PAGE_LOAD_START, key: itemKey, objectId: slug });
    try {
      let result = await courseLandingPage.getCourseLandingPageBySlug(slug);
      dispatch({ type: COURSE_LANDING_PAGE_LOAD_COMPLETE, data: result.data, key: itemKey, objectId: slug });
    } catch(error) {
      const err = toSerializableError(error);
      dispatch({ type: COURSE_LANDING_PAGE_LOAD_ERR, error: err, key: itemKey, objectId: slug });
    }
  }
}